module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C264"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("NAOKO AWA")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "C323"
  }, [_vm._v("Translated by Toshiya Kamei")]), _vm._v(" "), _c('p', {
    staticClass: "C256"
  }, [_c('em', [_vm._v("Gifts from the Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "C312"
  }, [_vm._v("At summer’s end, the seaside town celebrated its annual festival. After all the bathers had gone home, some men carried the mikoshi shrine through the streets, while others beat the taiko drums. In the evenings the narrow path along the sea was lined on both sides with vendors.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Even the hardest-working fisherman and the innkeeper took a break from work and had a good time. The townspeople drank sake and danced in broad daylight. At night they went out and strolled among the vendors.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Peddlers came from faraway towns, displayed their various articles on makeshift stands, and hawked them with loud cries. Various goods lined the path lit by a soft light: fountain pens, cigarette lighters, toys, candies, and potted plants.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("A chill wind blew from the sea. Accompanying the roar of the small-town festival, the waves on the shore sang: “Autumn is here. Autumn is here.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako had two fifty-yen coins in her skirt pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Why don’t you buy something you like?” her sick mother had said, placing the coins in her palm. As she clutched them, Kanako decided to buy two things costing fifty yen each—one for herself and another for her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("But there was hardly anything she could buy for fifty yen. A red crystal ring cost one hundred, a bead necklace cost one hundred fifty, and a pretty floral-print scarf cost five hundred.")])]), _c('p', {
    staticClass: "C327"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Young girls frolicked around in their best dresses, their hair tied in ribbons. While they bought rings and scarves, Kanako stood apart in her everyday clothes and looked at items she couldn’t afford to buy. But she was used to “window-shopping.” Kanako didn’t have a father. Her ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("mother had been sick as far back as she could remember. She was always poor and alone. Even so, she had spending money for the first time in a long time. Kanako walked with a light heart, wondering what she could buy for fifty yen.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "C327"
  }, [_vm._v("Then she heard a voice: “Fifty yen a bag.” Kanako stopped and saw a stand—an empty apple box—between an oden-stew stand and a goldfish booth. There sat an old woman with a scarf as blue as the midday sea, who stared at Kanako.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako went up to the old woman’s stand and saw small shiny items on the apple box. Are they buttons? she wondered, as she bent forward to take a closer look. They were shells.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Are you selling those?” asked Kanako. No one would want to buy shells because there are plenty of them on the beach, she thought, a bit disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“They’re all cherry-blossom shells, miss,” said the old woman, flashing a friendly smile.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("No one had ever called her “miss” before, and Kanako felt embarrassed.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Take a look. You won’t find shiny shells like these anywhere else.” The old woman placed shells on her palm.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("They were beautiful—as beautiful as scattered cherry blossom petals.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako silently placed one fifty-yen coin in front of the old woman. The old woman took out a small paper bag and put a handful of shells into it. “Miss, why don’t you buy another bag?” she said, as if she knew Kanako had one more fifty-yen coin in her skirt pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“No. I’m going to buy something for my mother,” said Kanako, shaking her head. She grabbed the bag of shells and left the old woman’s stand.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako put the bag in her blouse pocket and began to walk. Then the shells made sounds like dry sand falling softly.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Crunch, crunch, crunch. Crunch, crunch, crunch. Kana-chan. Crunch, crunch, crunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("The shells in her pocket sang to the rhythms of Kanako’s steps. Or rather Kanako walked to the tune of the shells’ song.")])]), _c('p', {
    staticClass: "C327"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“Crunch, crunch, crunch. Crunch, crunch, crunch. Kana-chan, Kana-chan. Crunch, crunch, crunch. Why don’t you go to the beach?”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "C327"
  }, [_vm._v("As the shells sang, Kanako’s feet guided her toward the beach before she realized it.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("She walked along the vendor-lined path, passed an abandoned shed at a bend, and reached a beach lit softly by the yellow moon in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Crunch, crunch, crunch. Crunch, crunch, crunch,” the shells sang. “Why don’t you keep going? Why don’t you go to the Moonview Rock?”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("The Moonview Rock stood by the lighthouse. Was it called that because it was a great place to watch the moon? Or was it because the rock itself was as round as the moon?")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Led by the shells’ song, Kanako went up to the rock, then saw several figures: one, two, three, five old women in sea-blue scarves.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("The old women surrounded the rock as if it were a table and huddled together, as if holding a secret meeting, their scarves fluttering in the wind. As Kanako went up on tiptoe, one old woman suddenly clapped, saying, “I won! I won!” Then the old woman next to her said, “It’s my turn.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako stood in a daze, as if she were dreaming. One of the old women turned around and beckoned her. “Why don’t you join us?”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako was speechless.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“You have some shells, don’t you?” asked the old woman. Seeing Kanako give a slight nod, she added, “You can join us if you have cherry-blossom shells.” The old women moved over and made room for Kanako. One of them gestured for Kanako to sit, saying, “Come here, quick!”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako sat before the rock as she was told. Then she opened her eyes wide in astonishment. The smooth surface of the dark rock was covered with peach-colored shells shining in the moonlight. She stared admiringly at the shells.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Put your shells here,” said the old woman beside her, breaking Kanako’s reverie.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako nodded, took out the bag from her pocket, and spread her shells out on the rock.")])]), _c('p', {
    staticClass: "C327"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“Let’s play again. Rock-paper-scissors, rock-paper-scissors!” cried the old woman with glasses on Kanako’s right.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "C327"
  }, [_vm._v("“We’re doing rock-paper-scissors to decide who goes first. We’re playing marbles,” the old woman on her left whispered as Kanako gaped in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“You know how to play marbles, don’t you?” the old woman across from Kanako said impatiently. “Look, if you hit someone else’s shell, you keep it.” She pretended to pick up a shell with her long-nailed fingers and put it in the bosom of her kimono. Kanako nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Are you ready? Let’s start!” cried the old woman with glasses. Then the six players started a strange marble tournament, taking turns as decided by rock-paper-scissors.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("The cherry-blossom shells slid on the smooth surface of the rock. Every time the old women won a shell, they jumped up with joy. But Kanako wasn’t doing well at all. Maybe her hands were too small and her nails weren’t sharp enough to shoot a shell. Kanako’s shell didn’t move an inch forward.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Too bad. Next!” the old women cried in chorus, every time Kanako failed. Her cheeks turned red, and her heart began to race. If I don’t do well this time, I’ll lose all my shells, she thought.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("No matter how hard she tried, Kanako couldn’t win a single shell. After Kanako shot dozens of times, the old woman next to her took the last shell, leaving the rock empty. The old woman with the most shells scooped them up in her hands and smiled: “Let’s play one more time!”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Without a single shell, Kanako had no choice but to quit. No one wanted to play with her anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("I should’ve bought another bag, Kanako thought. Surely she could get her shells back if she had one more bag. As she fumbled in her skirt pocket, the coin felt cold and hard against her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Wait. I’ll be back soon!” Kanako cried and began to run, her skirt swelling in the sea breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "C216"
  }, [_vm._v(".   .   .")])]), _c('p', {
    staticClass: "C327"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Kanako went darting through the belt of orange light along the vendors, toward the old woman’s apple box, which was almost hidden between the goldfish booth and the steam rising from the oden-stew stand.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "C327"
  }, [_vm._v("She stopped, out of breath. She looked at the spot where the old woman had been, but she had disappeared without trace—the goldfish booth and the oden-stew stand stood right next to each other, with no space between them.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("There stood a man with a white hachimaki around his head. “How about oden stew, miss?” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“What happened to the stand here?” Kanako asked, gasping for breath.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“No idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“An old woman with a blue scarf was selling cherry-blossom shells here,” said Kanako.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Then the oden-stew vendor laughed, saying, “That was a sea witch.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“Yeah, a sea witch. She comes to the festival at night, sells strange things to kids, and tricks them out of their money before sneaking back into the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Kanako turned pale. I was cheated, she thought. Bitterness filled her throat, as her heart began to throb. She stood still for a while, then turned and started running toward the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("“I want my fifty yen back! Or my cherry-blossom shells!” she shouted inside her head as she ran. When she finally reached the beach, no one was there.")]), _vm._v(" "), _c('p', {
    staticClass: "C327"
  }, [_vm._v("Where did the old women go? Kanako wondered. Did they stop playing marbles? She felt as if she were dreaming. She plodded toward the Moonview Rock. There she found a lot of marbles—or rather cherry-blossom shells. She went closer. When she picked up one, one shell after another came with it, strung on a thin thread. While she was gone, the shells had turned into a pair of splendid necklaces.")])]), _c('p', {
    staticClass: "C327"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Kanako looked around again, but the beach was still empty—except for the waves breaking into white foam, which sounded like the old ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("women’s laughter. Kanako thought she heard their mischievous whisper. They seemed to say, “These are yours. These are yours.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "C327"
  }, [_vm._v("The shell necklaces hanging from her arm, Kanako hurried home. “Mother, look what I’ve brought you. We have matching necklaces—gifts from a sea witch,” she whispered as she walked along the moonlit beach.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d941954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Translated_by_Toshiya_Kamei_Gift.vue
// module id = 78
// module chunks = 0